import { BeckyTopology, ModuleFetcher } from '@wix/thunderbolt-becky-types'
import { componentsMappers } from '@wix/thunderbolt-components-native'
import { BeckyModel } from '../../types/becky'
import { getEditorElementsAssetUrl } from '../utils/assetsUrl'

const getTbElementsModule = async ({
	moduleFetcher,
	tbElementsSiteAssets,
	topology,
}: {
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	topology: BeckyTopology
}) => {
	if (!tbElementsSiteAssets || tbElementsSiteAssets === 'undefined' || !moduleFetcher) {
		return undefined
	}
	const fromUrl = getEditorElementsAssetUrl(tbElementsSiteAssets, topology)
	return moduleFetcher.fetch({ fromUrl })
}

export const getComponentMappers = async ({
	moduleFetcher,
	tbElementsSiteAssets,
	topology,
	experiments,
}: {
	moduleFetcher?: ModuleFetcher
	tbElementsSiteAssets?: string
	topology: BeckyTopology
	experiments: BeckyModel['experiments']
}) => {
	if (!experiments['specs.thunderbolt.editor_elements_site_assets']) {
		return componentsMappers
	}
	const module = await getTbElementsModule({ moduleFetcher, tbElementsSiteAssets, topology })
	const tbElementsMappers = module?.default ?? module
	return { ...componentsMappers, ...tbElementsMappers }
}
